import React, { useMemo } from 'react'

import { TFunc } from '@/types'

interface IPopoverContext {
  onClose: TFunc
  closeOnOutside: boolean
}

export const PopoverContext = React.createContext<IPopoverContext>({
  onClose: () => {
    throw new Error('PopoverContext setIsShow should be used under provider')
  },
  closeOnOutside: true,
})

export const PopoverContextProvider: React.FC<{
  onClose: TFunc
  closeOnOutside?: boolean
  children: React.ReactNode
}> = ({ onClose, children, closeOnOutside }) => {
  const values = useMemo(
    () => ({
      onClose,
      closeOnOutside: !!closeOnOutside,
    }),
    [onClose, closeOnOutside],
  )

  return (
    <PopoverContext.Provider value={values}>{children}</PopoverContext.Provider>
  )
}
